import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Hovered = props => {
  const [hovered, setHovered] = useState(false);

  const handleOnMouseEnter = () => setHovered(true);
  const handleOnMouseLeave = () => setHovered(false);

  const { children, style } = props;

  const hoveredRow = hovered ? 'rgba(0, 0, 0, 0.15)' : 'transparent';

  return (
    <div
      {...props}
      style={{ ...style, backgroundColor: hoveredRow }}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      {children}
    </div>
  );
};
Hovered.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  style: PropTypes.shape({}).isRequired,
};
export default Hovered;
